import React from "react";
import "./CharacterCard.css";

const CharacterCard = () => (
  <div className="character-sheet">
    <div className="character-sheet-row">
      <div className="character-sheet-list">
        <h2 className="character-sheet-heading">🧙‍♂️ Character Sheet</h2>
        <ul className="character-list">
          <li>
            <b>Name:</b> The Architect (aka You Know Who)
          </li>
          <li>
            <b>Class:</b> Backend Developer
          </li>
          <li>
            <b>Level:</b> 69
          </li>
          <li>
            <b>Race:</b> Human (probably)
          </li>
          <li>
            <b>Alignment:</b> Chaotic Neutral (but highly functional)
          </li>
          <li>
            <b>Guild Tenure:</b> 2 years
          </li>
          <li>
            <b>Background:</b> Former Engineer — reforged through the fires of
            backend sorcery
          </li>
        </ul>
      </div>
      <div className="avatar-duck-container">
        <img
          src={process.env.PUBLIC_URL + "/avatar.png"}
          alt="Avatar"
          className="character-avatar"
        />
        <img
          src={process.env.PUBLIC_URL + "/duck.png"}
          alt="Duck"
          className="duck-overlay"
        />
      </div>
    </div>
    <h3>🎯 Base Attributes</h3>
    <table className="attributes-table">
      <thead>
        <tr>
          <th>Attribute</th>
          <th>Score (1d20)</th>
          <th>Modifier</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>API Alchemy</td>
          <td>14</td>
          <td>+2</td>
        </tr>
        <tr>
          <td>Automation Mastery</td>
          <td>14</td>
          <td>+2</td>
        </tr>
        <tr>
          <td>Database Taming</td>
          <td>15</td>
          <td>+2</td>
        </tr>
        <tr>
          <td>Business Logic Craft</td>
          <td>14</td>
          <td>+2</td>
        </tr>
        <tr>
          <td>Scalability Sense</td>
          <td>13</td>
          <td>+1</td>
        </tr>
        <tr>
          <td>Debugging Endurance</td>
          <td>16</td>
          <td>+3</td>
        </tr>
        <tr>
          <td>Refactor Discipline</td>
          <td>12</td>
          <td>+1</td>
        </tr>
        <tr>
          <td>Documentation Luck</td>
          <td>11</td>
          <td>+0</td>
        </tr>
        <tr>
          <td>Stack Overflow Wisdom</td>
          <td>16</td>
          <td>+3</td>
        </tr>
      </tbody>
    </table>
    <h3>⚔️ Skill Proficiencies</h3>
    <ul className="skills-list">
      <li>🛡 API Integration (Proficient)</li>
      <li>🧪 Automation Rituals (Proficient)</li>
      <li>📊 MongoDB Dungeon Crawling (Journeyman)</li>
      <li>🩻 Debugging Necromancy (Adept)</li>
      <li>🧙‍♂️ Business Logic Enchantments (Proficient)</li>
      <li>🔄 Scalability Runes (Initiate)</li>
      <li>🧹 Code Refactoring (Journeyman)</li>
    </ul>
    <h3>🎒 Inventory of Power</h3>
    <ul className="inventory-list">
      <li>⚔️ Node.js Blade of Asynchronous Fury</li>
      <li>🧝‍♂️ Python Staff of Business Logic</li>
      <li>📜 MongoDB Grimoire of Indexed Secrets</li>
      <li>💠 React Amulet of UI Binding</li>
      <li>🦆 Legendary Rubber Duck of Sanity</li>
      <li>☕ Potion of Endless Caffeine</li>
      <li>💾 USB Stick of Infinite Backups</li>
      <li>🧰 The Debugger’s Toolkit (Rare Artifact)</li>
    </ul>
    <h3>🌌 Backstory</h3>
    <p className="backstory">
      Once a craftsman of precision instruments in the industrial realms, the
      Architect left behind the world of hardware to pursue the arcane arts of
      backend development. Studying ancient digital scrolls and venturing
      through countless online dungeons, he mastered APIs, databases, and
      automation — commanding systems through code.
      <br />
      <br />
      Now, with two years of real-world adventuring under his belt, he traverses
      the ever-shifting dungeons of software architecture — forging
      integrations, slaying bottlenecks, and automating all that can be
      automated.
      <br />
      <br />
      His journey has only begun.
    </p>
    <h3>🗺 Current Campaign</h3>
    <ul className="campaign-list">
      <li>
        <b>Questline:</b> Build scalable, maintainable systems that defy chaos.
      </li>
      <li>
        <b>Side Quests:</b>
        <ul>
          <li>Master deeper system design patterns</li>
          <li>Expand into cloud and distributed realms</li>
          <li>Forever level up the art of automation</li>
        </ul>
      </li>
    </ul>
    <h3>🧟 Known Weaknesses</h3>
    <ul className="weakness-list">
      <li>Occasional feature creep temptation</li>
      <li>May refactor for sport</li>
      <li>Distracted by shiny new frameworks</li>
    </ul>
    <blockquote className="character-quote">
      “The code is never finished. Only deployed.”
    </blockquote>
  </div>
);

export default CharacterCard;
